module.exports = __webpack_public_path__ + "src/assets/img/loader-green.f7471dba.svg";